import { ReactNode } from 'react';
import AtSubButton from '../atoms/AtSubButton';
type Props = {
  children: ReactNode;
  buttonName: string;
  disabled?: boolean;
  onClick?: (e: React.UIEvent<Element, UIEvent>) => void;
};
/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const OrSubButtonArea = ({
  children,
  buttonName,
  disabled,
  onClick
}: Props) => {
  return <div className='orsubbuttonarea'>
      <AtSubButton name={buttonName} className='sub' disabled={disabled} onClick={onClick}>
        {children}
      </AtSubButton>
    </div>;
};
/** 初期値の設定 */
OrSubButtonArea.defaultProps = {
  disabled: false,
  onClick: null
};
/** 初期値の設定 */
export default OrSubButtonArea;